import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'

// Compact jump list. Answered and unanswered differ by icon and by the
// button's accessible name, not by colour.
const QuestionNavigator = ({ questions, answeredIds, currentIndex, onSelect }) => {
  const answeredCount = questions.filter((question) => answeredIds.has(question.id)).length
  return (
    <Box component="nav" aria-label="Questions" sx={{ mt: 3 }}>
      <Typography sx={{ mb: 1 }}>
        {answeredCount} of {questions.length} answered
      </Typography>
      <Box component="ol" sx={{ listStyle: 'none', display: 'flex', flexWrap: 'wrap', gap: 1, p: 0, m: 0 }}>
        {questions.map((question, index) => {
          const answered = answeredIds.has(question.id)
          const current = index === currentIndex
          return (
            <li key={question.id}>
              <ButtonBase
                onClick={() => onSelect(index)}
                aria-label={`Question ${index + 1}, ${answered ? 'answered' : 'not answered'}`}
                aria-current={current ? 'step' : undefined}
                sx={{
                  minWidth: 56,
                  minHeight: 44,
                  px: 1,
                  gap: 0.5,
                  border: current ? '3px solid' : '1px solid',
                  borderColor: current ? 'text.primary' : 'text.secondary',
                  borderRadius: 1,
                  fontFamily: 'inherit',
                  fontSize: '1rem',
                  fontWeight: current ? 700 : 400,
                }}
              >
                {index + 1}
                {answered ? (
                  <CheckCircleIcon fontSize="small" aria-hidden="true" />
                ) : (
                  <RadioButtonUncheckedIcon fontSize="small" aria-hidden="true" />
                )}
              </ButtonBase>
            </li>
          )
        })}
      </Box>
      <Typography sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
        <CheckCircleIcon fontSize="small" aria-hidden="true" /> Answered
        <RadioButtonUncheckedIcon fontSize="small" aria-hidden="true" sx={{ ml: 1.5 }} /> Not answered
      </Typography>
    </Box>
  )
}

export default QuestionNavigator
